const statusClass = (status: string) => {
  const map: Record<string, string> = {
    completed: 'bg-green-100 text-green-700',
    pending: 'bg-yellow-100 text-yellow-700',
    failed: 'bg-red-100 text-red-700',
    reversed: 'bg-gray-100 text-gray-600',
    canceled: 'bg-gray-100 text-gray-600',
    expired: 'bg-gray-100 text-gray-600',
    abandoned: 'bg-gray-100 text-gray-600',
  };
  return map[status.toLowerCase()] ?? 'bg-gray-100 text-gray-600';
};

export const TransactionStatusBadge = ({ status }: { status: string }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${statusClass(status)}`}
  >
    {status}
  </span>
);
